import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  signal,
  model,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { provideNativeDateAdapter } from "@angular/material/core";
import { DatePipe } from "@angular/common";
import { MatCalendar } from "@angular/material/datepicker";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { KnBrCheckoutService } from "src/app/services/kn-br-checkout-service";
import { Router } from "@angular/router";
import { Subscription, take } from "rxjs";

@Component({
  selector: "knbr-cwt-checkout-schedule-delivery",
  imports: [
    MatCardModule,
    MatDatepickerModule,
    MatCalendar,
    ReactiveFormsModule
],
  templateUrl: "./cwt-checkout-schedule-delivery.component.html",
  styleUrl: "./cwt-checkout-schedule-delivery.component.scss",
  providers: [provideNativeDateAdapter(), DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CwtCheckoutScheduleDeliveryComponent implements OnInit, OnDestroy {
  @ViewChild('calendar') calendar: MatCalendar<Date>;
  scheduleForm: FormGroup;
  selected = model<Date | null>(null);
  activeDate = signal(new Date());
  isExpanded = signal(true);
  allSubscriptions = new Subscription();
  deliveryMode: string;
  isScheduleDelivery: boolean = false;
  storeDeliveryAddress:any = {};
  currentUrl = '';
  storeName: any;
disabledDatesNew=[];
  calendarReady: boolean;
  constructor(
    private datePipe: DatePipe,
    private checkoutFlowService: CheckoutFlowService,
    protected checkoutService: KnBrCheckoutService,
    protected router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.currentUrl = this.router.url;
    if (this.currentUrl.includes('/checkout')) {
      this.checkoutService.isCheckout$.next(true);
    }
  }

  ngOnInit(): void {
    this.getcurrentURL();
       this.scheduleForm = this.fb.group({
      pickUpType: ["SCHEDULE"],
      pickUpDate: [],
      storePickupOption: ["in-store"],
    });
    this.allSubscriptions.add(
      this.checkoutService.getHolidaysList().subscribe((res: any) => {
        if (res) {
          this.disabledDatesNew = this.convertDisabledDatesToTime(res);
          this.getCartResponse()
          this.calendarReady = false;
          setTimeout(() => {
            this.calendarReady = true;
            this.cdr.detectChanges()
          });
        }
      })
    )


 
    if (this.isScheduleDelivery) {
      this.scheduleForm.get("storePickupOption")?.disable();
      this.scheduleForm.get("pickUpType")?.disable();
    }
    this.scheduleForm.get("pickUpType")?.valueChanges.subscribe((type) => {
      if (type === "IMMEDIATE") {
         const nextAvailableBusinessDate = this.getNextAvailableBusinessDateForImmediatePickup()
          this.scheduleForm.patchValue({
      pickUpDate: nextAvailableBusinessDate
    });
        this.checkoutFlowService.setSelectedDate("Immediate Pickup");
        // this.scheduleForm.get("pickUpDate")?.setValue(null);
      } else {
        this.checkoutFlowService.setSelectedDate(null);
        this.selected.set(null);
        if(this.isLastDayOfMonthAfter2PM())
          setTimeout(() => {
        const nextMonthDate = new Date();
        nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
        this.calendar.activeDate = nextMonthDate;
      });
      }
    });

 }

 getCartResponse() {
   this.allSubscriptions.add( this.checkoutFlowService.mode$.subscribe((mode) => {
      this.deliveryMode = mode;
    }))
    this.allSubscriptions.add(
      this.checkoutFlowService.getCart().subscribe((cartResp) => {
        this.storeDeliveryAddress = cartResp.deliveryAddress;
        this.storeName = cartResp?.storeName;
      if(cartResp.deliveryContactInfo.pickUpType ==='IMMEDIATE'){
        this.scheduleForm.patchValue({pickUpType:'IMMEDIATE'})
          const availableBusinessDate = this.getNextAvailableBusinessDateForImmediatePickup() // next available business date for immediate pickup
          console.log("logging data", availableBusinessDate);
          
        this.checkoutFlowService.setSelectedDate("Immediate Pickup");
        this.scheduleForm.patchValue({
          pickUpDate: availableBusinessDate
        });
      
      }
       else  if(cartResp.deliveryContactInfo.scheduledDeliveryDate){
          this.scheduleForm.patchValue({pickUpType:'SCHEDULE'})
          //  this.selected.set(this.parseAPIDate(cartResp.deliveryContactInfo.scheduledDeliveryDate));
          const scheduledDate = this.parseAPIDate(cartResp.deliveryContactInfo.scheduledDeliveryDate);
    this.scheduleForm.patchValue({
      pickUpDate: scheduledDate 
    });
      this.selected.set(scheduledDate);
           
        const date=
        this.datePipe.transform(cartResp.deliveryContactInfo.scheduledDeliveryDate, "MMMM d, y")
        this.checkoutFlowService.setSelectedDate(date);
      }
      
      })
    )   
 }
  parseAPIDate(dateStr: string): Date {
  const [month, day, year] = dateStr.split('/');
  return new Date(Number(year), Number(month) - 1, Number(day));
}
  getcurrentURL() {
    const currentURL = window.location.href;
    if (currentURL.includes("schedule-delivery"))
      this.isScheduleDelivery = true;
  }
convertDisabledDatesToTime(dates: string[]): number[] {
  return dates.map(d => {
    // Convert string to Date
    const date = new Date(d);

    // Normalize to start of day (local time)
    date.setHours(0, 0, 0, 0);

    return date.getTime();
  });
}
 skipWeekends(date: Date): Date {
  const newDate = new Date(date);
  while (newDate.getDay() === 0 || newDate.getDay() === 6 || this.isHoliday(newDate)) {
    newDate.setDate(newDate.getDate() + 1);
  }
  return newDate;
}

adjustDatesSkippingWeekends(dates: Date[]): Date[] {
  const adjusted: Date[] = [];
  let current: Date | null = null;
  for (const d of dates) {
    current = this.skipWeekends(d);
    while (adjusted.some(prev => prev.getTime() === current!.getTime())) {
      current.setDate(current.getDate() + 1);
      current = this.skipWeekends(current);
    }
    adjusted.push(current);
  }

  return adjusted;
}

isHoliday(date: Date): boolean {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return this.disabledDatesNew.includes(d.getTime());
}

  disablePastDates = (date: Date | null): boolean => {
    if (!date) return false;
     const now = new Date();
    const today = new Date();

    // Incremmenting by 1 day to make sure time is set to start of next day as per the requirement.
    today.setDate(today.getDate() + 1);

    today.setHours(0, 0, 0, 0);


    const isSameDate = (d1: Date, d2: Date): boolean =>
      d1.getTime() === d2.getTime();

    if (!this.isScheduleDelivery) {
      const isBefore2PM = this.getStoreHourEST() <= 14;
      const startDate = new Date(today);
      if (!isBefore2PM) {
        startDate.setDate(startDate.getDate() + 1);
      }

      const tempDates: Date[] = [];
      for (let i = 0; i < 10; i++) {
       const nextDate = new Date(startDate);
      nextDate.setDate(startDate.getDate() + i);
       tempDates.push(nextDate);
      }
      const validDates = this.adjustDatesSkippingWeekends(tempDates).slice( 0, 5 );

      return validDates.some((valid) => isSameDate(valid, date));
    }

    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() + 14);
    const nextAvailableDate = this.skipWeekends(date);
    return (
      nextAvailableDate >= today &&
      nextAvailableDate <= maxDate &&
      isSameDate(nextAvailableDate, date)
    );
  };

  

  ngAfterViewInit(): void {
    if (this.isLastDayOfMonthAfter2PM()) {
      setTimeout(() => {
        const nextMonthDate = new Date();
        nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
        this.calendar.activeDate = this.skipWeekends(nextMonthDate);
        this.updateNavigationButtons();
      });
    } else {
      this.updateNavigationButtons();
    }
    this.calendar?.stateChanges.subscribe(() => {
      this.updateNavigationButtons();
    });
  }

  updateNavigationButtons() {
    setTimeout(() => {
      const prevBtn = document.querySelector<HTMLElement>(
        ".mat-calendar-previous-button"
      );
      const nextBtn = document.querySelector<HTMLElement>(
        ".mat-calendar-next-button"
      );

      if (!prevBtn || !nextBtn) return;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + 14);

      const activeMonth = this.calendar.activeDate.getMonth();
      const activeYear = this.calendar.activeDate.getFullYear();

      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();

      const maxMonth = maxDate.getMonth();
      const maxYear = maxDate.getFullYear();

      if (this.isScheduleDelivery) {
        if (currentMonth === maxMonth && currentYear === maxYear) {
          prevBtn.setAttribute("disabled", "true");
          nextBtn.setAttribute("disabled", "true");
        } else {
          if (activeYear === currentYear && activeMonth === currentMonth) {
            prevBtn.setAttribute("disabled", "true");
            nextBtn.removeAttribute("disabled");
          } else if (activeYear === maxYear && activeMonth === maxMonth) {
            prevBtn.removeAttribute("disabled");
            nextBtn.setAttribute("disabled", "true");
          } else {
            prevBtn.setAttribute("disabled", "true");
            nextBtn.setAttribute("disabled", "true");
          }
        }
      } else {
        if (activeMonth === currentMonth && activeYear === currentYear) {
          prevBtn.setAttribute("disabled", "true");
        } else {
          prevBtn.removeAttribute("disabled");
        }

        if (this.isLastDayOfMonthAfter2PM()) {
          nextBtn.removeAttribute("disabled");
        } else {
          nextBtn.setAttribute("disabled", "true");
        }
      }
    });
  }

  isLastDayOfMonthAfter2PM(): boolean {
    const now = new Date();
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return (
      now.getDate() === lastDayOfMonth.getDate() &&
      now.getHours() >= 14
    );
  }


  getNextAvailableBusinessDateForImmediatePickup(): Date {

  // Start from today at midnight
   let candidate = new Date();
  candidate.setHours(0, 0, 0, 0);

  // After 4 PM  start from next day
  if (this.getStoreHourEST() >= 16) {
    candidate.setDate(candidate.getDate() + 1);
  }

  // Keep moving forward until a valid business day is found
  while (
    candidate.getDay() === 0 ||               // Sunday
    candidate.getDay() === 6 ||               // Saturday
    this.isHoliday(candidate)                 // Holiday
  ) {
    candidate.setDate(candidate.getDate() + 1);
  }

  return candidate;
}



  selectedDate(event: Date) {
    this.selected.set(event);
    this.checkoutFlowService.setSelectedDate(this.getFormattedDate());
    this.scheduleForm.get("pickUpDate")?.setValue(event);
  }

  formatToISOStringStartOfDay(date: Date): string {
    const year = date?.getFullYear();
    const month = this.padZero(date?.getMonth() + 1); 
    const day = this.padZero(date?.getDate());
    return `${year}-${month}-${day}T00:00:00`;
  }

  padZero(value: number): string {
    return value < 10 ? "0" + value : value?.toString();
  }

  getFormattedDate(): any {
    const date = this.selected();
    return date ? this.datePipe.transform(date, "MMMM d, y") ?? "" : "";
  }
  toggleSection() {
    this.isExpanded.set(!this.isExpanded());
  }

  onSubmit() {
    const formValues = this.scheduleForm.getRawValue();
    const pickUpPayload = {
      pickUpType: formValues.pickUpType,
      pickUpDate: formValues?.pickUpDate?this.formatToISOStringStartOfDay(formValues?.pickUpDate):'',
    };
    const routeValue = this.getRouteInfo();
    if (this.router.url.includes("checkout/pickup-store")) {
      this.allSubscriptions.add(
        this.checkoutService.setPickUpTypeAndDate(pickUpPayload).pipe(take(1)).subscribe({
          next: (resp) => {
            this.router.navigateByUrl("checkout/payment");
            this.checkoutFlowService.markCompleted(
              this.deliveryMode,
              routeValue
            );
          },
          error: (err) => {
            console.log("pickup store api got failed");
          },
        })
      );
    } else {
      const deliveryPayload = {
        scheduledDeliveryDate: this.formatToISOStringStartOfDay(
          formValues.pickUpDate
        ),
      };
      this.checkoutService.setScheduleDeliveryDate(deliveryPayload).subscribe({
        next: (resp) => {
          this.checkoutFlowService.markCompleted(this.deliveryMode, routeValue);
          console.log("set schedule delivery section api success");
          this.router.navigateByUrl("/checkout/delivery-instructions");
        },
        error: (err) => {
          console.log("set schedule delivery api failed");
        },
      });
    }
  }

  getRouteInfo() {
    const segments = this.router.url.split("/").filter(Boolean);
    const lastTwo = segments.slice(-2).join("/");
    return lastTwo;
  }

  get pickUpTypeControl() {
    return this.scheduleForm.get('pickUpType');
  }

  getStoreHourEST(): number {
  return Number(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric',
      hour12: false
    }).format(new Date())
  );
}
getESTDateObject() {
    const now = new Date();
    const estTime = new Date(
        now.toLocaleString("en-US", { timeZone: "America/New_York" })
    );
    return estTime;
}
  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe()
  }
}
